<template lang="pug">
section
  s-page-title(title='Все товары')
    template(slot='extension')
      v-btn(@click='onEdit()' color='primary' depressed) Добавить
  v-card
    s-data-filter(@search='debouncedSearch' :initial='dataFilter.search')
        template(slot='controls')

    v-data-table(
      :loading='isLoading'
      :headers='headers'
      :items='list'
      :total-items='total'
      :pagination='dataFilter'
      @update:pagination='updatePagination'
    )
      template(slot='items' slot-scope='props')
        tr(class='with-pointer' @click='onEdit(props.item)')
          td {{ props.item.id }}
          td {{ props.item.name }}
          td {{ props.item.annotation }}
          td {{ props.item.actual_price }}
          td {{ props.item.old_price }}
          td
            template(v-if='props.item.avatar')
              v-img(
                :aspect-ratio='1'
                :lazy-src='props.item.avatar_url'
                :src='props.item.avatar_url'
                class='grey lighten-4'
                contain
              )
                v-layout(
                  slot='placeholder'
                  fill-height
                  align-center
                  justify-center
                  ma-0
                )
                  v-progress-circular(indeterminate color='primary')

          td(class='text-xs-right wrapless crud-tools')
            v-btn(icon @click.stop='onDelete(props.item)')
              v-icon(small) delete_outline
            s-publish-status-toggle(
              :value='props.item'
              @success='fetch'
              resource='shop/goods'
            )
</template>

<script>
import { debounce } from 'lodash'
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'

export default {
  data: () => ({
    headers: [
      {
        text: '#ID',
        align: 'left',
        value: 'id',
        width: '0%',
        sortable: true
      },
      {
        text: 'Название товара',
        align: 'left',
        value: 'name',
        width: '100%',
        sortable: true
      },
      {
        text: 'Краткое описание',
        align: 'left',
        value: 'annotation',
        width: '0%'
      },
      {
        text: 'Актуальная цена',
        align: 'left',
        value: 'actual_price',
        width: '0%',
        sortable: true
      },
      {
        text: 'Новая цена',
        align: 'left',
        value: 'old_price',
        width: '0%',
        sortable: true
      },
      {
        text: 'Основная картинка товара',
        align: 'left',
        value: 'avatar',
        width: '0%'
      },
      {
        text: '',
        align: 'left',
        width: '0%',
        sortable: false
      }
    ]
  }),

  created() {
    this.fetch()
  },

  methods: {
    updatePagination(pagination) {
      this.setDataFilter(pagination)
      this.fetch()
    },

    onEdit({ id } = {}) {
      this.$router.push({
        name: 'Shop.Goods.Edit',
        params: { id }
      })
    },

    fetch() {
      this.fetchList({ config: { params: this.dataFilter } })
    },

    async onDelete({ id }) {
      if (!(await this.$confirm('Вы уверены?'))) return

      try {
        await this.destroy({ id })
      } catch (e) {
        this.$root.showSnack('Ошибка удаления')
      }

      this.fetch()
    },

    debouncedSearch: debounce(function(search) {
      this.setDataFilter({ search, page: 1 })
      this.fetch()
    }, 250),

    ...mapActions('shop/goods', ['fetchList', 'destroy']),
    ...mapMutations('shop/goods', ['setDataFilter'])
  },

  computed: {
    ...mapState('shop/goods', ['total', 'dataFilter']),
    ...mapGetters('shop/goods', ['list', 'isLoading'])
  }
}
</script>
